import {translate} from '../utils';
import $ from 'jquery';
import {disableSubmitButton, enableSubmitButton} from '../enable_disable_button';
import {createRoot} from 'react-dom/client';
import {createElement, StrictMode} from 'react';
import {InputOTP} from '../components/InputOTP';
import {flushSync} from 'react-dom';

let submitPromise = null;
let submitPromiseResolve = null;
const loginForm = document.getElementById('loginForm');
const $loginForm = $(loginForm);

$loginForm.on('beforeValidate', () => {
    // `beforeSubmit` event is called with a 200ms delay. To avoid double click,
    // disabling the button in `beforeSubmit` wont work if user is fast enough
    if ($loginForm.yiiActiveForm('data').submitting) {
        disableSubmitButton(
            loginForm.querySelector('button[type="submit"]'),
        );

        submitPromise = new Promise((resolve) => {
            submitPromiseResolve = resolve;
        });
    }
}).on('afterValidate', (event, messages, errorAttributes) => {
    if (errorAttributes.length > 0 && $loginForm.yiiActiveForm('data').submitting) {
        submitPromiseResolve(false);
        submitPromise = submitPromiseResolve = null;
        enableSubmitButton(
            loginForm.querySelector('button[type="submit"]'),
        );
    }
}).on('beforeSubmit', () => {
    hideError();

    fetch(loginForm.action, {
        method: loginForm.method,
        body: new FormData(loginForm),
        headers: {
            'Accept': 'application/json'
        },
    }).then(async (response) => {
        if (response.status === 400) {
            document.getElementById('csrfWarning').classList.remove('hidden');

            submitPromiseResolve(false);
            submitPromise = submitPromiseResolve = null;

            enableSubmitButton(
                loginForm.querySelector('button[type="submit"]'),
            );
        } else {
            const body = await response.json();

            if (typeof body === 'string') {
                submitPromiseResolve(true);
                submitPromise = submitPromiseResolve = null;
                window.location.href = body;
            } else {
                submitPromiseResolve(false);
                submitPromise = submitPromiseResolve = null;

                if (Array.isArray(body)) {
                    showCredentialsStep();
                    showError(body[0]);
                } else if (isOtpError(body)) {
                    if (otpRoot) {
                        showError(body.otp);
                    }
                    showOtpStep(body.two_fa_channel ?? 'otp');
                } else {
                    for (let field in body) {
                        if (field !== 'otp' && field !== 'two_fa_channel') {
                            showError(body[field]);
                            break;
                        }
                    }
                    showCredentialsStep();
                }

                enableSubmitButton(
                    loginForm.querySelector('button[type="submit"]'),
                );
            }
        }
    }).catch(() => {
        if (submitPromiseResolve) {
            submitPromiseResolve(false);
            submitPromise = submitPromiseResolve = null;
        }

        showError(translate('frontend', 'ERROR_INPROCESS'));

        enableSubmitButton(
            loginForm.querySelector('button[type="submit"]'),
        );
    });

    return false;
});

function isOtpError(body) {
    const keys =  new Set(Object.keys(body));

    return keys.has('otp')
        && (!keys.has('two_fa_channel') || body.two_fa_channel === 'otp' || body.two_fa_channel === 'email')
        && !keys.has('username')
        && !keys.has('password')
        && !keys.has('propertyid');
}

function onOtpComplete() {
    loginForm.querySelector('button[type="submit"]').click();
    return submitPromise;
}

function showError(error) {
    const errorEl = document.getElementById('formError');
    errorEl.classList.remove('hidden');
    errorEl.innerText = error;
}

function hideError() {
    document.getElementById('formError').classList.add('hidden');
}

let otpRoot = null;

function showOtpStep(channel) {
    document.getElementById('credentialFields').classList.add('hidden');
    document.getElementById('credentialsIntro').classList.add('hidden');
    document.getElementById('forgotPassword')?.classList.add('hidden');

    // The support login renders the same form without the field.
    const channelInput = document.getElementById('twoFaAuthChannel');
    if (channelInput) {
        channelInput.value = channel;
    }

    const otpIntro = document.getElementById('otpIntro');
    otpIntro.innerText = channel === 'email'
        ? translate('frontend', 'LOGIN_CODE_INSTRUCTIONS')
        : translate('frontend', '2FA_OTP_INSTRUCTIONS');

    document.getElementById('otpFields').classList.remove('hidden');
    otpIntro.classList.remove('hidden');

    if (!otpRoot) {
        const otpFields = document.getElementById('otpFields');
        otpRoot = createRoot(otpFields)
        flushSync(() => {
            otpRoot.render(
                createElement(StrictMode, null, createElement(InputOTP, {
                    onComplete: onOtpComplete,
                    name: otpFields.dataset.inputName,
                })),
            );
        })
    }
}

function showCredentialsStep() {
    document.getElementById('credentialFields').classList.remove('hidden');
    document.getElementById('credentialsIntro').classList.remove('hidden');
    document.getElementById('forgotPassword')?.classList.remove('hidden');

    document.getElementById('otpFields').classList.add('hidden');
    document.getElementById('otpIntro').classList.add('hidden');

    if (otpRoot) {
        flushSync(() => {
            otpRoot.unmount();
        });
        otpRoot = null;
    }
}
